export enum Theme {
  Light = "Light",
  Dark = "Dark",
}

export const MOBILE_BREAKPOINT = 768;
